/**
 * Question identifiers for suicidal ideation and self-harm screening across different assessments.
 */
export const HIGH_ALERT_QUESTION_KEYS = {
  PHQ9_SI: 'phq9_9',
  PHQ9_SI_PLAN: 'phq9_9_1',
  PHQ9_SI_INTENT: 'phq9_9_2',
  CHECK_IN_SI: 'suicideIdeation',
  CHECK_IN_SELF_HARM: 'selfHarm',
  CHRT_SI_THOUGHTS: 'chrt_10',
  CHRT_SI_THOUGHTS_HOW: 'chrt_11',
  CHRT_SI_PLAN: 'chrt_12',
  RCADS_THOUGHTS_ABOUT_DEATH: 'rcads25_18',
  CLIENT_INTAKE_ATTEMPTED_SUICIDE: 'suicide',
  CLIENT_INTAKE_SELF_INJURY: 'selfInjury',
} as const
